module.exports = __webpack_public_path__ + "258ef5c951b1f8996f61f3fc07ab0a16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/tradition_unclear.svg
// module id = 40
// module chunks = 0